const VRN_CURRENCIES = ['AUD'];

const VRN_BANK_DETAILS = {
  AUD: {
    accountName: 'SENDFX LIMITED CMA',
    bankName: 'JP Morgan Chase Bank',
    swiftCode: 'CHASAU2X',
    bankAddress: 'CASTLEREAGH STREET, 83-85, FLOOR 18, Sydney, NSW, 2000',
  },
};
const VRN_GENERAL_ACKNOWLEDGEMENT_LIMIT_DATES = {
  AUD: '2024-01-01',
};
module.exports = {
  VRN_CURRENCIES,
  VRN_BANK_DETAILS,
  VRN_GENERAL_ACKNOWLEDGEMENT_LIMIT_DATES,
};
